/**
 * Limited-time "free messages" offer (October 2026).
 *
 * The window is expressed as fixed instants — Riyadh (UTC+3, no DST)
 * midnights — so the API and the web client agree without any time-zone
 * handling. Both sides read these constants; nothing is stored in the DB.
 */
export const FREE_MESSAGES_OFFER = {
  /** 2026-10-12 18:00 Asia/Riyadh (the announced date is 13 Oct; opened early). */
  startsAt: "2026-10-12T15:00:00.000Z",
  /** 2026-10-20 00:00 Asia/Riyadh (exclusive). */
  endsAt: "2026-10-19T21:00:00.000Z",
  /**
   * Driver-sent messages per conversation (the shipment template included)
   * that cost nothing while the offer runs; the next one is charged normally.
   */
  freeMessagesPerConversation: 10,
  /**
   * Free new shipments (template sends) per driver per Riyadh day; beyond it
   * the template costs the usual credit even inside the offer.
   */
  dailyShipmentCap: 100,
} as const;

/**
 * Whether the offer should be advertised: from now until it ends, so the
 * banner announces it before the start and keeps showing while it runs.
 */
export function isFreeMessagesOfferAdvertised(now: Date = new Date()): boolean {
  return now.getTime() < Date.parse(FREE_MESSAGES_OFFER.endsAt);
}

export function isFreeMessagesOfferActive(now: Date = new Date()): boolean {
  const t = now.getTime();
  return (
    t >= Date.parse(FREE_MESSAGES_OFFER.startsAt) &&
    t < Date.parse(FREE_MESSAGES_OFFER.endsAt)
  );
}

/** Start of the current Riyadh (UTC+3) calendar day, as an instant. */
export function riyadhDayStart(now: Date = new Date()): Date {
  const offsetMs = 3 * 60 * 60 * 1000;
  const dayMs = 24 * 60 * 60 * 1000;
  const shifted = now.getTime() + offsetMs;
  return new Date(Math.floor(shifted / dayMs) * dayMs - offsetMs);
}
